export default "__VITE_ASSET__BSjZysGR__"